<template>
  <div
    class="fts-clipboard"
    @mouseenter="showAction = true"
    @mouseleave="showAction = false"
  >
    <div class="clipboard-copy">
      <slot />
    </div>
    <div class="clipboard-action" v-if="!loading && copy && (showAction || isCopied)">
      <div class="clipboard-hint" v-if="isCopied">Copied</div>
      <fts-btn
        slot="reference"
        text
        icon
        sm
        :color="isCopied ? 'success' : 'default'"
        v-clipboard:copy="copy"
        v-clipboard:success="onCopy"
        v-clipboard:error="onError"
      >
        <font-awesome-icon :icon="['fas', 'check']" v-if="isCopied" />
        <font-awesome-icon :icon="['far', 'clone']" v-else />
      </fts-btn>
    </div>
    <div class="clipboard-loading-overlay" v-if="loading">
      <fts-spinner :size="16" show />
    </div>
  </div>
</template>

<script>
import FTSBtn from './FTSBtn';
import FTSSpinner from './FTSSpinner';

export default {
  props: {
    copy: {
      required: false
    },
    loading: Boolean
  },
  components: {
    "fts-btn": FTSBtn,
    "fts-spinner": FTSSpinner
  },
  data: () => ({
    isCopied: false,
    showAction: false
  }),
  methods: {
    onCopy() {
      if (!this.isCopied) {
        this.isCopied = true;
        setTimeout(() => {
          this.isCopied = false;
        }, 2000);
      }
    },
    onError() {
      console.error('clipboard copy error');
    }
  }
}
</script>

<style lang="scss" scoped>
@use "./src/assets/scss/vars" as *;

.fts-clipboard {
  position: relative;
  min-height: $form-control-height;
  padding: 0.375rem 0.75rem;
  border: 1px solid rgba(var(--fts-gray-100-rgb), 0.75);
  border-radius: $border-radius;
  background-color: rgba(var(--fts-gray-100-rgb), 0.75);
  .clipboard-copy {
    font-size: $font-size;
    line-height: $line-height;
    word-break: break-all;
  }
  .clipboard-hint {
    @include absolute-center-y;
    right: 2.5rem;
    padding: 0.125rem 0.25rem;
    box-shadow: var(--fts-elevation-2);
    border-radius: 0.25rem;
    background-color: var(--fts-popover-background);
    color: var(--fts-light);
    font-size: 0.75rem;
  }
  .clipboard-action {
    position: absolute;
    top: 0.125rem;
    right: 0.25rem;
    border-radius: $border-radius;
    box-shadow: var(--fts-elevation-2);
    background-color: var(--fts-popover-alt-background);
    > .fts-btn {
      border-radius: inherit;
    }
  }
  .clipboard-loading-overlay {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    @include backdrop-filter(blur(2px));
    background-color: rgba(var(--fts-gray-50-rgb), 0.75);
  }
}
</style>